import styled from "styled-components";
import Theme from '../../Styles/Themes';
import config from '../../Config/config.json';

export const Container = styled.div`
    display: flex;
    width: 100%;
    height: 100vh;
    justify-content: flex-start;
    align-items: center;
    background-color: #fff;
    position: absolute;
`;

export const MobileGradiante = styled.div`
    display: flex;
    width: 100%;
    border-radius: 100px 0px 0px 100px;
    max-width: 520px;
    align-items: center;
    justify-content: flex-end;
    background: radial-gradient(100% 75% at 8% 35%, #4361EE 0%, #3C9 100%);
    height: 100%;
    @media (max-width: 992px) {
        background: linear-gradient(90deg, #3C9 0%, #4361EE 100%);
        justify-content: center;
        align-items: flex-end;
        border-radius: 50px 50px 0px 0px;
        height: 75%;
    }
`;

export const BlueContainer = styled.div`
    display: flex;
    width: 100%;
    height: 100vh;
    justify-content: flex-start;
    align-items: center;
    background: #006560;
    padding-left: 5%;
    @media (max-width: 992px) {
        padding-left: 0;
        align-items: flex-start;
        justify-content: center;
    }
`;

export const Title = styled.h1`
    display: flex;
    color: #FFF;
    text-shadow: 0px 1.5px 2.5px rgba(0, 0, 0, 0.35);
    font-size: 40px;
    font-style: normal;
    font-weight: 700;
    line-height: normal;
    @media (min-width: 1060px) {
        font-size: 60px;
    }
    @media (min-width: 1200px) {
        font-size: 80px;
    }
    @media (min-width: 1400px) {
        font-size: 100px;
    }
`;

export const LoginCotaniner = styled.div`
    display: flex;
    position: absolute;
    width: 100%;
    height: 100vh;
    z-index: 10;
    justify-content: flex-end;
    align-items: center;
    @media (max-width: 992px) {
        align-items: flex-end;
        justify-content: center;
    }
`;

export const LoginBox = styled.div`
    display: flex;
    flex-direction: column;
    justify-content: flex-start;
    align-items: center;
    background: ${Theme[config.theme].colors.primaryBackground};
    width: 98%;
    height: 99%;
    margin: 5px 0px 5px 5px;
    padding-inline: 50px;
    gap: 15px;
    border-radius: 100px 0px 0px 100px;
    overflow: auto;
    @media (max-width: 992px) {
        padding: 0;
        border-radius: 50px 50px 0px 0px;
        margin: 5px 5px 0px 5px;
        width: 100%;
        height: 96%;
        max-width: 500px;
    }
`;

export const ContainerForm = styled.div`
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    width: 90%;
    height: 100%;
    @media (max-width: 992px) {
        margin-top: 40px;
        justify-content: flex-start
    }
`;

export const CaptchaContainer = styled.div`
    display: flex;
    margin-bottom: 15px;
`;

export const SaveUser = styled.div`
    display: flex;
    width: 90%;
    justify-content: flex-end;
    align-items: center;
    margin-bottom: 10px
`;

export const SaveButton = styled.button`
    display: flex;
    flex-direction: row;
    justify-content: flex-end;
    align-items: center;
    background: transparent;
    border: none;
    flex-wrap: nowrap;
    white-space: nowrap;
    cursor: pointer;
    transition: 1s;
    border-radius: 15px;
    font-size: ${Theme[config.theme].font.paragraphs[config.fontSize].size};
    font-weight: ${Theme[config.theme].font.paragraphs[config.fontSize].weight};
    line-height: ${Theme[config.theme].font.paragraphs[config.fontSize].line_height};
    color: ${Theme[config.theme].colors.primaryFontColor};
    gap: 15px;

    &: hover{
        scale: 1.2;
    }
`;

export const PasswordRecovery = styled.button`
    display: flex;
    width: 90%;
    justify-content: center;
    align-items: center;
    background: transparent;
    border: none;
    font-size: ${Theme[config.theme].font.paragraphs[config.fontSize].size};
    font-weight: ${Theme[config.theme].font.paragraphs[config.fontSize].weight};
    line-height: ${Theme[config.theme].font.paragraphs[config.fontSize].line_height};
    color: ${Theme[config.theme].colors.primaryFontColor};
    gap: 5px;
    cursor: pointer;
    margin-top: 15px;
`;

export const Image = styled.img`
    display: flex;
    width: 280px;
    height: 55px;
    margin-bottom: 25px;
    @media (max-width: 992px) {
        display: none
    }
`;

export const ImageMobile = styled.img`
    display: flex;
    width: 280px;
    height: 55px;
    margin-top: 20px;
`;

export const Wellcometext = styled.h2`
    color: #333;
    text-align: center;
    font-size: 26.996px;
    font-style: normal;
    font-weight: 400;
    line-height: normal;
    letter-spacing: -1.35px;
    margin-bottom: 40px;
`;